module.exports = __webpack_public_path__ + "static/img/logo_7.a0f4fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_7.png
// module id = bwbx
// module chunks = 1